import jwt from "jwt-decode";

export const getToken = () => localStorage.getItem("nextGenToken");
export const setToken = (token) => localStorage.setItem("nextGenToken", token);
export const removeToken = () => localStorage.removeItem("nextGenToken");
export const isAuth = () => Boolean(getToken());

export const decodeJwt = (tk) => {
  return jwt(tk);
};

export const convertDate = (date) => {
  if (date) {
    const inputDate = new Date(date);
    return inputDate.toISOString();
  }
};

export const preventBack = () => {
  return window.history.forward();
};

export const getDateRange = (range) => {
  const now = new Date();
  let startDate = new Date();
  let endDate = new Date();

  switch (range) {
    case "lastWeek":
      endDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59, 59, 999));
      startDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - 7, 0, 0, 0, 0));
      break;

    case "lastMonth":
      startDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1, 0, 0, 0, 0));
      endDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0, 23, 59, 59, 999));
      break;

    case "lastYear":
      startDate = new Date(Date.UTC(now.getUTCFullYear() - 1, 0, 1, 0, 0, 0, 0));
      endDate = new Date(Date.UTC(now.getUTCFullYear() - 1, 11, 31, 23, 59, 59, 999));
      break;

    default:
      startDate = null;
      endDate = new Date();
      break;
  }

  return {
    startDate: startDate ? startDate.toISOString() : "",
    endDate: endDate.toISOString(),
  };
};

export const convertToUTC = (date) => {
  if (typeof date === "string") {
    return new Date(date).toUTCString()
  }

  return date.toUTCString()
}
